/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_GeneralInputs */

const en_enum_setting_group_general = /** @type {(inputs: Enum_Setting_Group_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group General`)
};

const de_enum_setting_group_general = /** @type {(inputs: Enum_Setting_Group_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe General`)
};

/**
* | output |
* | --- |
* | "Group General" |
*
* @param {Enum_Setting_Group_GeneralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_general = /** @type {((inputs?: Enum_Setting_Group_GeneralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_GeneralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_general(inputs)
	return de_enum_setting_group_general(inputs)
});